import defaultConfig from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/default/config.json';
import accountingcomConfig from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/accounting.com/config.json';
import accreditedschoolsonlineorgConfig from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/accreditedschoolsonline.org/config.json';
import bestcollegescomConfig from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/bestcolleges.com/config.json';
import nursejournalorgConfig from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/nursejournal.org/config.json';
import psychologyorgConfig from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/psychology.org/config.json';
import thebestschoolsorgConfig from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/thebestschools.org/config.json';
import affordablecollegesonlineorgConfig from '@highereducation/edu-product-toolkit-publishers/dist/data/publishers/affordablecollegesonline.org/config.json';

var _a;
var defaultConfigTyped = defaultConfig;
var accountingcomConfigTyped = accountingcomConfig;
var accreditedschoolsonlineorgConfigTyped = accreditedschoolsonlineorgConfig;
var bestcollegescomConfigTyped = bestcollegescomConfig;
var nursejournalorgConfigTyped = nursejournalorgConfig;
var psychologyorgConfigTyped = psychologyorgConfig;
var thebestschoolsorgConfigTyped = thebestschoolsorgConfig;
var affordablecollegesonlineorgConfigTyped = affordablecollegesonlineorgConfig;
var preloadedPublisherConfigs = (_a = {},
    _a[defaultConfigTyped.publisherName] = defaultConfigTyped,
    _a[accountingcomConfigTyped.publisherName] = accountingcomConfigTyped,
    _a[accreditedschoolsonlineorgConfigTyped.publisherName] = accreditedschoolsonlineorgConfigTyped,
    _a[bestcollegescomConfigTyped.publisherName] = bestcollegescomConfigTyped,
    _a[psychologyorgConfigTyped.publisherName] = psychologyorgConfigTyped,
    _a[nursejournalorgConfigTyped.publisherName] = nursejournalorgConfigTyped,
    _a[thebestschoolsorgConfigTyped.publisherName] = thebestschoolsorgConfigTyped,
    _a[affordablecollegesonlineorgConfigTyped.publisherName] = affordablecollegesonlineorgConfigTyped,
    _a);

export { preloadedPublisherConfigs as default };
